import { call, put, takeEvery } from 'redux-saga/effects'
import { privateFetch } from '../../../fetch'
import { generalDoFailure } from '../../../util/fetchFailure'

import { API_URL_PATH_KEG_COLLECTIONS } from '../../../../../constants'

import { DELETE_KEG_COLLECTION } from '../../../../actions/actionTypes'

import {
  deleteKegCollectionRequest,
  deleteKegCollectionSuccess,
  deleteKegCollectionFailure,
} from './utils'

function* deleteKegCollectionRequestWorker(action) {
  if (!action) return

  const { kegCollectionId } = action.payload || {}

  yield put(deleteKegCollectionRequest())

  try {
    yield call(privateFetch, {
      path: `${API_URL_PATH_KEG_COLLECTIONS}/${kegCollectionId}`,
      method: 'DELETE',
    })
    yield call(doSuccess)
  } catch (error) {
    yield call(doFailure, { error })
  }
}

export default [[takeEvery, DELETE_KEG_COLLECTION, deleteKegCollectionRequestWorker]]

function* doSuccess() {
  yield put(deleteKegCollectionSuccess())
}

function* doFailure({ error }) {
  yield call(generalDoFailure, {
    error,
    action: deleteKegCollectionFailure(error),
  })
}
